import React from 'react'
import { Location } from '@reach/router'

import Navigation from '../components/common/navigation/navigation'
import Layout from '../components/common/layout/layout'
import SEO from '../components/common/layout/seo'
import StartList from '../components/startlist/startlist'
import Footer from '../components/sections/footer'

const Start = () => {
  return (
    <Location>
      {locationProps => (
        <Layout>
          <SEO />
          <Navigation {...locationProps} />
          <StartList />
          <Footer />
        </Layout>
      )}
    </Location>
  )
}

export default Start
